module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('h2', {
    staticClass: "fmh",
    attrs: {
      "id": "ch4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781789742671_EPUB5#ch4"
    }
  }, [_vm._v("SELECT BIBLIOGRAPHY")])]), _vm._v(" "), _c('h2', {
    staticClass: "ahd1"
  }, [_c('strong', {
    staticClass: "bold"
  }, [_vm._v("Commentaries on Philippians")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bird, Michael and Nijay K. Gupta (2020), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philippians")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("New Cambridge Bible Commentary (Cambridge: Cambridge University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bockmuehl, Markus (1997), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Epistle to the Philippians")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("BNTC (London: A. & C. Black).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Cohick, Lynn. H. (2013), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philippians")]), _vm._v(", Story of God Bible Commentary (Grand Rapids: Zondervan).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fee, Gordon D. (1995), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul’s Letter to the Philippians")]), _vm._v(", NICNT"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Flemming, Dean (2009), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philippians")]), _vm._v(", New Beacon Bible Commentary (Kansas City: Beacon Hill).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fowl, Stephen E. (2005), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philippians")]), _vm._v(", Two Horizons New Testament Commentary (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gupta, Nijay K. (2020),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Reading Philippians: A Theological Introduction")]), _vm._v(", Cascade Companions (Eugene: Cascade).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hansen, G. Walter (2009), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Letter to the Philippians")]), _vm._v(", Pillar New Testament Commentary (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hawthorne, Gerald F. (1983),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Philippians")]), _vm._v(", WBC 43 (Waco: Word).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hellerman, Joseph H. (2015), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philippians")]), _vm._v(", Exegetical Guide to the Greek New Testament (Nashville: B&H Academic).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Holloway, Paul A. (2017),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Philippians")]), _vm._v(", Hermeneia (Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hooker, Morna (2000), ‘Philippians’, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NIB")]), _vm._v(" 11 (Nashville: Abingdon), pp. 467–549.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hunsinger, George (2020), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philippians")]), _vm._v(", Brazos Theological Commentary on the Bible (Grand Rapids: Brazos).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Keown, Mark J. (2017), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philippians")]), _vm._v(", Evangelical Exegetical Commentary, 2 vols."), _c('em', {
    staticClass: "italic"
  }), _vm._v("(Bellingham: Lexham).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Lightfoot, J. B. (1953), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Saint Paul’s Epistle to the Philippians: A Revised Text, with Introduction, Notes, and Dissertations")]), _vm._v(", repr. (Grand Rapids: Zondervan).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Martin, Ralph P. (1959), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Epistle of Paul to the Philippians")]), _vm._v(", TNTC"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Migliore, Daniel L. (2014),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Philippians and Philemon")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("Belief: A Theological Commentary on the Bible, 1st edn (Louisville: Westminster John Knox).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Osiek, Carolyn (2000), ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philippians, Philemon")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(", ANTC")]), _c('em', {
    staticClass: "italic"
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("(Nashville: Abingdon).")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Reumann, John (2008), ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philippians: A New Translation with Introduction and Commentary")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(", AB (New Haven: Yale University Press).")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Silva, Mois")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("é")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("s (2005), ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philippians")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(", BECNT, 2nd edn (Grand Rapids: Baker).")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Stubbs, Monya A. (2007), ‘Philippians’, in Brian K. Blount, Cain Hope Felder, Clarice Jannette Martin and Emerson B. Powery (eds.),")]), _c('em', {
    staticClass: "italic"
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("True to Our Native Land: An African American New Testament Commentary ")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("(Minneapolis: Fortress), pp. 363–379.")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Tamez, Elsa (2017), ‘Philippians’, in Elsa Tamez, Cynthia Briggs Kittredge, Claire Miller Colombo and Alicia J. Batten,"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Philippians, Colossians, Philemon")]), _vm._v(", Wisdom Commentary (Collegeville: Liturgical), pp. 1–122.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Thielman, Frank (1995), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philippians")]), _vm._v(", NIV Application Commentary"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(Grand Rapids: Zondervan).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Thurston, B. and J. M. Ryan (2005), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philippians and Philemon")]), _vm._v(", SP"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(Collegeville: Liturgical).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Works, Carla Swafford (2012), ‘Philippians’, in Carol A. Newsom, Sharon H. Ringe and Jacqueline E. Lapsley (eds.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Women’s Bible Commentary")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("3rd edn (Louisville: Westminster John Knox), pp. 581–584.")]), _vm._v(" "), _c('h2', {
    staticClass: "ahd1"
  }, [_c('strong', {
    staticClass: "bold1"
  }, [_vm._v("Other commentaries, books, monographs and articles")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Achtemeier, Paul J. (1990), ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Omne Verbum Sonat")]), _vm._v(":"), _c('em', {
    staticClass: "italic"
  }), _vm._v("The New Testament and the Oral Environment of Late Western Antiquity’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL")]), _vm._v(" 109, pp. 3–27.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Alexander, Loveday (1989), ‘Hellenistic Letter-Forms and the Structure of Philippians’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JSNT ")]), _vm._v("37, pp. 87–101.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Barclay, John M. G. (2017),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Paul and the Gift")]), _vm._v(" (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Barr, James (1961), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Semantics of Biblical Language ")]), _vm._v("(Oxford: Oxford University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bauckham, R. (2008), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jesus and the God of Israel ")]), _vm._v("(Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Becker, Eve-Marie (2020),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Paul on Humility")]), _vm._v(", tr. and ed. Wayne Coppins (Waco: Baylor University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Becknell, Thomas and Mary Ellen Ashcroft (1995),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" The Beginning of Wisdom: Prayers for Growth and Understanding")]), _vm._v(" (Nashville: Moorings).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bertschmann, Dorothea H. (2018), ‘Is There a Kenosis in This Text? Rereading Philippians 3:2–11 in the Light of the Christ Hymn’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL")]), _vm._v(" 137, pp. 235–254.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bockmuehl, Markus N. A. (1996), ‘A Commentator’s Approach to the “Effective History” of Philippians’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JSNT")]), _vm._v(" 18, pp. 57–88.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bormann, Lukas (1995), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philippi: Stadt und Christengemeinde zur Zeit des Paulus ")]), _vm._v("(Leiden: Brill).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Boyce, James L. ‘Rhetoric and the Word of God: Treasure in Earthen Vessels’, in David S. Cunningham (ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("To Teach, to Delight, and to Move: Theological Education in a Post-Christian World")]), _vm._v(" (Eugene: Cascade, 2004), pp. 201–222.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Brackley, Dean (1988), ‘Downward Mobility: Social Implications of St. Ignatius’s Two Standards’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Studies in the Spirituality of the Jesuits ")]), _vm._v("20, pp. 1–50.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Brewer, Raymond Rush (1954), ‘The Meaning of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Politeuesthe")]), _vm._v(" in Philippians 1:27’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL")]), _vm._v(" 73, pp. 76–83.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Brown, Jeannine K. (2009), ‘Apostle, I: New Testament’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("EBR ")]), _vm._v("1, pp. 471–476.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2017), ‘The Love between Paul and the Philippian Believers’, in Paul N. Jackson (ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Devotions on the Greek New Testament")]), _vm._v(", vol. 2"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(Grand Rapids: Zondervan), pp. 93–95.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2019), ‘Reconstructing the Historical Pharisees: Does Matthew’s Gospel Have Anything to Contribute?’, in Darrell L. Bock and J. Ed Komoszewski (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jesus, Skepticism, and the Problem of History: Criteria and Context in the Study of Christian Origins")]), _vm._v(" (Grand Rapids: Zondervan), pp. 164–182.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2020), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Gospels as Stories: A Narrative Approach to Matthew, Mark, Luke, and John")]), _vm._v(" (Grand Rapids: Baker Academic).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2021), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scripture as Communication: Introducing Biblical Hermeneutics")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("2nd edn"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(Grand Rapids: Baker Academic).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (forthcoming), ‘Letter to the Philippians’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("DPL")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Brown, Jeannine K., Carla M. Dahl and Wyndy Corbin Reuschling (2011),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Becoming Whole and Holy: An Integrative Conversation about Christian Formation")]), _vm._v(" (Grand Rapids: Brazos).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Brown, Jeannine K. and Nickolas Fox (forthcoming), ‘Hermeneutics/Interpreting Paul’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("DPL")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Brown, Jeannine K. and Kyle Roberts (2018),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Matthew")]), _vm._v(", Two Horizons New Testament Commentary (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Brown, Jeannine K. and Steven J. Sandage (2015), ‘Relational Integration: Relational Integration as Developmental and Intercultural 2’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of Psychology & Theology")]), _vm._v(" 43, pp. 179–191.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Brueggemann, Walter (1999), ‘The Liturgy of Abundance, the Myth of Scarcity’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ChrCent")]), _vm._v(" 116, pp. 342–347.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Capper, B. J. (1993), ‘Paul’s Dispute with Philippi: Understanding Paul’s Argument in Phil 1 – 2 from His Thanks in 4:10–20’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("TZ ")]), _vm._v("49, pp. 193–214.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Childs, Brevard S. (2008), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Church’s Guide for Reading Paul: The Canonical Shaping of the Pauline Corpus ")]), _vm._v("(Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Croy, N. C. (2003), ‘“To Die Is Gain” (Philippians 1:19–26): Does Paul Contemplate Suicide?’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL")]), _vm._v(" 122, pp. 517–531.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Cunningham, David S. (ed.) (2004), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("To Teach, to Delight, and to Move: Theological Education in a Post-Christian World ")]), _vm._v("(Eugene: Cascade).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Daley, Brian (2006),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Gregory of Nazianzus")]), _vm._v(" (London: Taylor & Francis).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("deSilva, David (2016), ‘Appeals to “Logos”, “Pathos”, and “Ethos” in Galatians 5:1–12: An Investigation of Paul’s “Inventio”’, in Stanley E. Porter (ed.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Paul and Ancient Rhetoric: Theory and Practice in the Hellenistic Context")]), _vm._v(" (New York: Cambridge University Press), pp. 245–264.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Droge, Arthur J. (1988), ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mori Lucrum")]), _vm._v(": Paul and Ancient Theories of Suicide’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NovT ")]), _vm._v("30, pp. 262–286.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Du Mez, Kristin Kobes (2020),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Jesus and John Wayne: How White Evangelicals Corrupted a Faith and Fractured a Nation ")]), _vm._v("(New York: Liveright/Norton).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Eastman, Susan Grove (2008), ‘Imitating Christ Imitating Us: Paul’s Educational Project in Philippians’, in J. R. Wagner, C. K. Rowe and A. K. Grieb (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Word Leaps the Gap: Essays in Scripture and Theology in Honor of Richard B. Hays")]), _vm._v(" (Grand Rapids: Eerdmans), pp. 427–451.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2011), ‘Philippians 2:6–11: Incarnation as Mimetic Participation’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal for the Study of Paul and His Letters")]), _vm._v(" 1, pp. 1–22.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2017),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Paul and the Person: Reframing Paul’s Anthropology")]), _vm._v(" (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Edwards, Dennis R. (2013), ‘Good Citizenship: A Study of Philippians 1:27 and Its Implications for Contemporary Urban Ministry’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ExAud ")]), _vm._v("29, pp. 74–93.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Elliott, J. K. (1993), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Testament Apocrypha")]), _vm._v(" (Oxford: Oxford University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fee, Gordon D. (1989), ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Laos")]), _vm._v(" and Leadership under the New Covenant’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Crux")]), _vm._v(" 25, pp. 3–13.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1998), ‘To What End Exegesis? Reflections on Exegesis and Spirituality in Philippians 4:10–20’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("BBR")]), _vm._v(" 8, pp. 75–88.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fellows, Richard G. (2016), ‘Name Giving by Paul and the Destinations of Acts’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("TynBul")]), _vm._v(" 67, pp. 247–268.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fellows, Richard G. and Alistair C. Stewart (2018), ‘Euodia, Syntyche and the Role of Syzygos: Phil 4:2–3’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ZNW")]), _vm._v(" 109, pp. 222–234.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fitzgerald, J. (ed.) (1996), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Friendship, Flattery, and Frankness of Speech: Studies on Friendship in the New Testament World")]), _vm._v(", NovTSup 82 (Leiden: Brill).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Flemming, Dean (2011), ‘Exploring a Missional Reading of Scripture: Philippians as a Case Study’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("EvQ")]), _vm._v(" 83, pp. 3–18.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Foster, Paul (2009), ‘")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Πίστις Χριστο")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("υ")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("̂")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Terminology in Philippians and Ephesians’, in Michael F. Bird and Preston M. Sprinkle (eds.),")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" The Faith of Jesus Christ: Exegetical, Biblical, and Theological Studies")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" (Peabody: Hendrickson), pp. 91–109.")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fowl, Stephen E. (1990), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Story of Christ in the Ethics of Paul")]), _vm._v(", JSNTSup (Sheffield: JSOT).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2002), ‘Know Your Context: Giving and Receiving Money in Philippians’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Int")]), _vm._v(" 56, pp. 45–58.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fredrickson, David E. (2013), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eros and the Christ: Longing and Envy in Paul’s Christology")]), _vm._v(" (Minneapolis: Augsburg Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fredriksen, Paula (2015), ‘Why Should a “Law-Free” Mission Mean a “Law-Free” Apostle?’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL")]), _vm._v(" 134, pp. 637–650.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gehring, Roger W. (2004), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("House Church and Mission: The Importance of Household Structure in Early Christianity")]), _vm._v(" (Peabody: Hendrickson).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gorman, Michael J. (2007), ‘“Although/Because He Was in the Form of God”: The Theological Significance of Paul’s Master Story (Phil 2:6–11)’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal for Theological Interpretation ")]), _vm._v("1, pp. 147–169.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2013), ‘Paul and the Cruciform Way of God in Christ’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of Moral Theology")]), _vm._v(" 2, pp. 64–83.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Green, Joel B. (2007),")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" 1 Peter")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(", Two Horizons New Testament Commentary (Grand Rapids: Eerdmans).")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Gupta, Nijay K. (2020), ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul and the Language of Faith")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" (Grand Rapids: Eerdmans).")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Heen, Erik M. (2004), ‘Phil 2:6–11 and Resistance to Local Timocratic Rule’, in Richard A. Horsley (ed.), ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul and the Roman Imperial Order ")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("(Harrisburg: Trinity Press International), pp. 125–153.")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Heilig, Christoph (2014), ‘Methodological Considerations for the Search of Counter-Imperial “Echoes” in Pauline Literature’, in John Anthony Dunne and Dan Batovici (eds.), ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reactions to Empire: Sacred Texts in Their Socio-Political Contexts ")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("(Tübingen: Mohr Siebeck), pp. 73–92.")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Hellerman, Joseph (2009), ‘")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("ΜΟΡΦΗ ΘΕΟΥ")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" as Signifier of Social Status in Philippians 2:6’, ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JETS")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" 52, pp. 779–797.")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Henderson, Timothy (2010), ‘Beware of Overlooked Allusions: A New Proposal for Intertextuality in Philippians 3’, Paper presented at Annual Meeting of the Upper Midwest Region of the SBL, St. Paul, MN, 10 April 2010.")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Holloway, P. A. (2001), ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Consolation in Philippians: Philosophical Sources and Rhetorical Strategy")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(", SNTSMS 112 (New York: Cambridge University Press).")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hooker, Morna D. (1971), ‘Interchange in Christ’,"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" JTS")]), _vm._v(" 22, pp. 349–361.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (1985), ‘Interchange in Christ and Ethics’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JSNT")]), _vm._v(" 8, pp. 3–17.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hurtado, Larry W. (1998),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" One God, One Lord: Early Christian Devotion and Ancient Jewish Monotheism")]), _vm._v(", 2nd edn (Edinburgh: T&T Clark).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Jeremias, Joachim (1963), ‘Zu Phil 2:7: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Heauton Ekenōsen")]), _vm._v("’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NovT")]), _vm._v(" 6, pp. 182–188.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Johnson, Luke Timothy (2020), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Constructing Paul: The Canonical Paul ")]), _vm._v("(Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kennedy, George A. (1984), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Testament Interpretation through Rhetorical Criticism ")]), _vm._v("(Chapel Hill: University of North Carolina).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Keener, Craig S. (2020),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Acts")]), _vm._v(", New Cambridge Bible Commentary (Cambridge: Cambridge University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Klauck, Hans-Josef (2006),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Ancient Letters and the New Testament: A Guide to Context and Exegesis")]), _vm._v(" , tr. and ed. Daniel P. Bailey (Waco: Baylor University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("McAuley, D. (2015), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul’s Covert Use of Scripture: Intertextuality and Rhetorical Situation in Philippians 2:10–16 ")]), _vm._v("(Eugene: Pickwick).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("McCaulley, Esau (2020), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reading while Black: African American Biblical Interpretation as an Exercise of Hope")]), _vm._v(" (Downers Grove: InterVarsity Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Martin, R. P. (1967), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Carmen Christi ")]), _vm._v("(Cambridge: Cambridge University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Mason, Steve (2000), ‘Pharisees’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("DNTB")]), _vm._v(", pp. 782–787.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Morris, Leon (1956), ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kai Hapax Kai Dis")]), _vm._v("’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NovT ")]), _vm._v("1, pp. 205–208.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Nanos, Mark D. (2009), ‘Paul’s Reversal of Jews Calling Gentiles “Dogs” (Philippians 3:2): 1600 Years of an Ideological Tale Wagging an Exegetical Dog?’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("BibInt")]), _vm._v(" 17, pp. 448–482.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Nikki, Nina (2019), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Opponents and Identity in Philippi")]), _vm._v(", NovTSup"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(Leiden: Brill).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Nongbri, Brent (2009), ‘Two Neglected Textual Variants in Philippians 1’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL ")]), _vm._v("128, pp. 803–808.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Novenson, Matthew V. (2005), ‘Re-Mapping the Universe: Paul and the Emperor in 1 Thessalonians and Philippians’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JSNT")]), _vm._v(" 27, pp. 301–322.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2012),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Christ among the Messiahs: Christ Language in Paul and Messiah Language in Ancient Judaism")]), _vm._v(" (New York: Oxford University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Oakes, P. (2001), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philippians: From People to Letter")]), _vm._v(", SNTSMS 110"), _c('em', {
    staticClass: "italic"
  }), _vm._v("(Cambridge: Cambridge University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Patterson, Jane Lancaster (2015),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Keeping the Feast: Metaphors of Sacrifice in 1 Corinthians and Philippians")]), _vm._v(" (Atlanta: SBL).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Peterlin, Davorin (1995), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul’s Letter to the Philippians in the Light of the Disunity in the Church")]), _vm._v(" (New York: Brill).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Peterman, Gerald W. (1997),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Paul’s Gift from Philippi: Conventions of Gift-Exchange and Christian Giving")]), _vm._v(" (Cambridge: Cambridge University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Peters, Ted (1994),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Sin: Radical Evil in Soul and Society")]), _vm._v(" (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Rapske, Brian (1994), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Book of Acts and Paul in Roman Custody ")]), _vm._v("(Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Reed, Jeffrey T. (1997),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" A Discourse Analysis of Philippians: Method and Rhetoric in the Debate over Literary Integrity")]), _vm._v(" (Sheffield: Sheffield Academic).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Sandage, Steven J., Mary L. Jensen and Daniel Jass (2008), ‘Relational Spirituality and Transformation: Risking Intimacy and Alterity’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of Spiritual Formation & Soul Care")]), _vm._v(" 1, pp. 182–206.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Sandage, Steven J., D. Rupert, G. S. Stavros and N. G. Devor (2020), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Relational Spirituality in Psychotherapy: Healing Suffering and Promoting Growth")]), _vm._v(" (Washington, DC: American Psychological Association).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Schnabel, Eckhard J. (2004), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Early Christian Mission: Paul and the Early Church ")]), _vm._v("(Downers Grove: InterVarsity Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Scott, Ian W. (2009),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Paul’s Way of Knowing: Story, Experience, and the Spirit")]), _vm._v(" (Grand Rapids: Baker Academic).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Smit, Peter-Ben (2013),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Paradigms of Being in Christ: A Study of the Epistle to the Philippians")]), _vm._v(" (London: Bloomsbury T&T Clark).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Smith, Julien C. H. (2020), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul and the Good Life: Transformation and Citizenship in the Commonwealth of God")]), _vm._v(" (Waco: Baylor University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Stowers, S. (1991), ‘Friends and Enemies in the Politics of Heaven’, in J. M. Bassler (ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pauline Theology")]), _vm._v(", vol. 1 (Minneapolis: Fortress), pp. 105–121.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Sumney, Jerry L. (2007), ‘Paul and Christ-Believing Jews Whom He Opposes’, in Matt Jackson-McCabe (ed.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Jewish Christianity Reconsidered: Rethinking Ancient Groups and Texts")]), _vm._v(" (Minneapolis: Fortress), pp. 57–80.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Thiselton, Anthony C. (2000),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" The First Epistle to the Corinthians")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("NIGTC (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wallace, Daniel B. (1996),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Greek Grammar beyond the Basics: An Exegetical Syntax of the New Testament – With Scripture, Subject, and Greek Word Indexes")]), _vm._v(" (Grand Rapids: Zondervan).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Weima, Jeffrey A. D. (2016),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Paul the Ancient Letter Writer: An Introduction to Epistolary Analysis")]), _vm._v(" (Grand Rapids: Baker Academic).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wenham, Gordon J. (1979),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" The Book of Leviticus")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("New International Commentary on the Old Testament (Grand Rapids: Eerdmans).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Willis, Wendall Lee (2012), ‘The Shaping of Character: Virtue in Philippians 4:8–9’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Restoration Quarterly ")]), _vm._v("54"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(", ")]), _vm._v("pp. 65–76.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2019), ‘Paul, the Gift and Philippians’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Horizons in Biblical Theology ")]), _vm._v("41, pp. 174–190.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Wright, N. T. (1986), ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Harpagmos")]), _vm._v(" and the Meaning of Philippians 2:5–11’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JTS")]), _vm._v(" 37, pp. 321–352.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2013),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Pauline Perspectives: Essays on Paul, 1978–2013")]), _vm._v(" (Minneapolis: Fortress).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2015), ‘Joy: Some New Testament Perspectives and Questions’, in Miroslav Volf and Justin E. Crisp (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Joy and Human Flourishing: Essays on Theology, Culture and the Good Life")]), _vm._v(" (Minneapolis: Fortress), pp. 39–62.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2019),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" History and Eschatology: Jesus and the Promise of Natural Theology ")]), _vm._v("(Waco: Baylor University Press).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Zoccali, Christopher (2011), ‘“Rejoice, O Gentiles, with His People”: Paul’s Intra-Jewish Rhetoric in Philippians 3:1–9’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("CTR")]), _vm._v(" 9, pp. 17–31.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("—— (2017), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reading Philippians after Supersessionism: Jews, Gentiles, and Covenant Identity ")]), _vm._v("(Eugene: Cascade).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8f20e08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781789742671_EPUB9.vue
// module id = 78
// module chunks = 0